import { render, staticRenderFns } from "./DetailInfoPeriod.vue?vue&type=template&id=6be0037c&scoped=true"
import script from "./DetailInfoPeriod.vue?vue&type=script&lang=js"
export * from "./DetailInfoPeriod.vue?vue&type=script&lang=js"
import style0 from "./DetailInfoPeriod.vue?vue&type=style&index=0&id=6be0037c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be0037c",
  null
  
)

export default component.exports